export const fuelPriceProviders = [
  {
    id: 'us-eia',
    name: 'US EIA National Diesel Fuel Price',
  },
  {
    id: 'breakthrough',
    name: 'Breakthrough®​',
  },
] as const

export const ALL_FUEL_PROVIDER_CODES = fuelPriceProviders.map(p => p.id)

export type FuelPriceProviderCode = (typeof ALL_FUEL_PROVIDER_CODES)[number]

export const displayFuelPriceProvider = (id: FuelPriceProviderCode) => {
  const provider = fuelPriceProviders.find(p => p.id === id)
  return provider?.name || 'Unknown'
}

export const getFuelChargeDetail = (provider: FuelPriceProviderCode) =>
  `Calculated via ${displayFuelPriceProvider(provider)}`

export const getFuelTableChargeDetail = (
  provider: FuelPriceProviderCode,
  fuelPrice: number,
) =>
  `Calculated from your fuel table at a fuel price of $${fuelPrice.toFixed(2)} (${displayFuelPriceProvider(provider)})`
